/* eslint-disable complexity */
/**
 * fontClass是从AI翻译的iconfont网页中的Font class类型中复制过来的，比如icon-fill-global_alert
 */
export type FontClass =
  | undefined
  | 'icon-fill_global_NewThread1'
  | 'icon-line-global_infinite'
  | 'icon-line_global_history2'
  | 'icon-line-global_down'
  | 'icon-fill_global_Send'
  | 'icon-line-global_Copy'
  | 'icon-line-global_reload1'
  | 'icon-line-global_search'
  | 'icon-line-global_left'
  | 'icon-line-global_right'
  | 'icon-line-global_Translate'
  | 'icon-line-global_TranslateClick1'
  | 'icon-line-global_Chat'
  | 'icon-line-global_ChatClick'
  | 'icon-line-global_Study'
  | 'icon-line-global_StudyClick1'
  | 'icon-line-global_CustomerService'
  | 'icon-shezhi'
  | 'icon-line-global_File'
  | 'icon-fill-global_FileClick'
  | 'icon-line-global_setup'
  | 'icon-line-global_FullScreen'
  | 'icon-line-global_close'
  | 'icon-biz-help'

type Props = {
  classNames?: string
  style?: React.CSSProperties
  fontClass: FontClass
}

export const SvgIcon = (props: Props) => {
  const { classNames = '', fontClass, style } = props

  if (fontClass === 'icon-line-global_infinite') {
    return (
      <svg
        className={classNames}
        style={{
          width: '1em',
          height: '1em',
          verticalAlign: 'middle',
          fill: 'currentColor',
          overflow: 'hidden',
          ...style,
        }}
        viewBox='0 0 1024 1024'
        version='1.1'
        xmlns='http://www.w3.org/2000/svg'
        fill='currentColor'
      >
        <path d='M762.56 288c61.696 0 112.832 25.28 147.968 73.728 33.28 42.048 49.472 97.408 49.472 165.184 0 66.048-16.192 121.216-49.984 166.016-34.56 47.616-85.76 72.96-147.456 72.96-48.256 0-100.8-29.568-159.36-84.352a1262.336 1262.336 0 0 1-91.264-98.944 1194.176 1194.176 0 0 1-91.136 98.944c-58.496 54.784-111.104 84.352-159.296 84.352-61.696 0-112.896-25.344-147.392-72.96-33.92-44.8-50.112-99.968-50.112-166.016 0-67.84 16.256-123.136 49.472-165.12C148.608 313.216 199.744 288 261.504 288c46.016 0 94.528 25.856 146.112 74.048l12.416 11.2c27.52 25.472 58.432 58.304 91.968 98.048a1131.968 1131.968 0 0 1 92.032-97.92l12.352-11.264c51.584-48.128 100.096-74.048 146.112-74.048V288zM261.504 376c-33.152 0-56.96 11.776-76.224 38.272-21.12 26.688-31.808 63.168-31.808 112.64 0 48.192 10.752 84.928 32.896 114.176 18.112 24.96 41.984 36.8 75.136 36.8 19.648 0 54.272-19.52 97.408-59.84 21.76-20.48 47.104-47.872 76.16-82.112l7.552-8.96-6.464-7.808A1015.936 1015.936 0 0 0 358.4 437.056l-22.4-20.16c-32.32-28.16-57.92-40.96-74.496-40.96z m501.056 0c-16.64 0-42.24 12.736-74.56 40.896l-22.4 20.16c-23.168 21.504-49.216 48.96-77.696 82.112l-6.528 7.744 7.552 9.024c29.12 34.24 54.4 61.568 76.16 82.112 43.2 40.32 77.888 59.84 97.472 59.84 33.152 0 56.96-11.776 75.136-36.8 22.144-29.248 32.832-65.984 32.832-114.176 0-49.472-10.624-85.952-31.744-112.64-19.2-26.496-43.072-38.272-76.224-38.272z'></path>
      </svg>
    )
  }

  if (fontClass === 'icon-fill_global_NewThread1') {
    return (
      <svg
        className={classNames}
        style={{
          width: '1em',
          height: '1em',
          verticalAlign: 'middle',
          fill: 'currentColor',
          overflow: 'hidden',
          ...style,
        }}
        viewBox='0 0 1024 1024'
        version='1.1'
        xmlns='http://www.w3.org/2000/svg'
        color='currentColor'
      >
        <path d='M766.933333 91.050667a192 192 0 0 1 192 192v368.597333a192 192 0 0 1-190.506666 192l-142.250667 1.066667c-36.352 0-69.546667 10.154667-99.285333 30.464L320 995.072a21.333333 21.333333 0 0 1-32-18.304l-0.938667-134.613333-4.437333-0.426667a624.128 624.128 0 0 0-29.738667-0.768 192 192 0 0 1-189.952-191.914667V283.050667a192 192 0 0 1 192-192h512z m-262.826666 217.088l-4.778667 0.213333c-23.253333 2.304-41.386667 21.162667-41.386667 44.16v73.685333H377.045333c-11.989333 0.085333-23.466667 4.693333-31.914666 12.8a42.069333 42.069333 0 0 0-13.098667 30.549334l0.213333 4.693333c2.432 21.845333 21.76 38.485333 44.842667 38.570667h80.768v73.813333a43.093333 43.093333 0 0 0 13.44 31.274667c8.661333 8.32 20.437333 13.013333 32.725333 13.098666l4.693334-0.213333c23.637333-2.432 41.514667-21.546667 41.429333-44.16v-73.813333h80.853333c12.032-0.042667 23.509333-4.650667 32-12.757334a42.069333 42.069333 0 0 0 13.098667-30.506666l-0.256-4.736c-2.432-21.888-21.76-38.528-44.8-38.613334h-80.853333V352.512c0-24.533333-20.650667-44.373333-46.122667-44.373333z'></path>
      </svg>
    )
  }

  if (fontClass === 'icon-line_global_history2') {
    return (
      <svg
        className={classNames}
        style={{
          width: '1em',
          height: '1em',
          verticalAlign: 'middle',
          fill: 'currentColor',
          overflow: 'hidden',
          ...style,
        }}
        viewBox='0 0 1024 1024'
        version='1.1'
        xmlns='http://www.w3.org/2000/svg'
        color='currentColor'
      >
        <path d='M512 96c229.76 0 416 186.24 416 416s-186.24 416-416 416S96 741.76 96 512 282.24 96 512 96z m0 64a352 352 0 1 0 0 704 352 352 0 0 0 0-704z m0 128a32 32 0 0 1 31.701333 27.648l0.298667 4.309333 0.128 178.986667 139.818667 139.776a32 32 0 0 1 3.114666 41.642667l-3.114666 3.584a32 32 0 0 1-41.642667 3.114666l-3.584-3.114666-149.205333-149.12a32 32 0 0 1-8.96-17.578667l-0.426667-5.034667-0.128-192.170666A32 32 0 0 1 512 288z'></path>
      </svg>
    )
  }

  if (fontClass === 'icon-line-global_down') {
    return (
      <svg
        className={classNames}
        style={{
          width: '1em',
          height: '1em',
          verticalAlign: 'middle',
          fill: 'currentColor',
          overflow: 'hidden',
          ...style,
        }}
        viewBox='0 0 1024 1024'
        version='1.1'
        xmlns='http://www.w3.org/2000/svg'
        color='currentColor'
      >
        <path d='M537.6 750.976a36.288 36.288 0 0 1-47.552 3.2l-3.712-3.2-341.312-341.312a36.288 36.288 0 0 1 47.552-54.528l3.712 3.2L512 673.984 827.712 358.4a36.288 36.288 0 0 1 47.552-3.2l3.712 3.2c12.992 12.992 14.08 33.408 3.2 47.616l-3.2 3.712-341.312 341.312z'></path>
      </svg>
    )
  }

  if (fontClass === 'icon-fill_global_Send') {
    return (
      <svg
        className={classNames}
        style={{
          width: '1em',
          height: '1em',
          verticalAlign: 'middle',
          fill: 'currentColor',
          overflow: 'hidden',
          ...style,
        }}
        viewBox='0 0 1024 1024'
        version='1.1'
        xmlns='http://www.w3.org/2000/svg'
        color='currentColor'
      >
        <path d='M529.792 877.482667a76.032 76.032 0 0 1-76.586667-75.52V385.834667l-108.8 107.136c-30.208 29.44-78.378667 29.44-108.586666 0a74.709333 74.709333 0 0 1 0-106.88l239.872-235.946667a77.525333 77.525333 0 0 1 83.541333-16.384 75.946667 75.946667 0 0 1 47.488 69.973333v598.186667a76.074667 76.074667 0 0 1-76.928 75.52z m245.418667-357.034667a76.288 76.288 0 0 1-54.144-22.186667L475.733333 257.024a74.709333 74.709333 0 0 1 0-106.88 77.738667 77.738667 0 0 1 108.544 0l245.376 241.493333a74.410667 74.410667 0 0 1 0 106.624 76.416 76.416 0 0 1-54.4 22.186667z'></path>
      </svg>
    )
  }

  if (fontClass === 'icon-line-global_Copy') {
    return (
      <svg
        className={classNames}
        style={{
          ...style,
        }}
        viewBox='0 0 1024 1024'
        version='1.1'
        xmlns='http://www.w3.org/2000/svg'
        color='currentColor'
      >
        <path d='M204.8 394.6496v405.248c0 21.2992 8.0896 41.728 22.528 56.832 14.336 15.0528 33.8944 23.552 54.272 23.552h307.2c20.3776 0 39.936-8.4992 54.272-23.552 14.4384-15.104 22.528-35.5328 22.528-56.832V394.6496c0-21.2992-8.0896-41.7792-22.528-56.832a75.1104 75.1104 0 0 0-54.272-23.552h-307.2c-42.3936 0-76.8 35.9936-76.8 80.384z m76.8 0h307.2v405.248h-307.2V394.6496zM396.8 153.6c-21.1968 0-38.4 17.9712-38.4 40.192v40.1408h384v408.832h38.4c21.1968 0 38.4-17.9712 38.4-40.192v-368.64c0-21.2992-8.0896-41.728-22.528-56.832A75.1104 75.1104 0 0 0 742.4 153.6H396.8z'></path>
      </svg>
    )
  }

  if (fontClass === 'icon-line-global_reload1') {
    return (
      <svg
        className={classNames}
        style={{
          ...style,
        }}
        viewBox='0 0 1024 1024'
        version='1.1'
        xmlns='http://www.w3.org/2000/svg'
        color='currentColor'
      >
        <path d='M577.024 825.408c-102.4 20.8-212.736-8-291.072-86.336a316.416 316.416 0 0 1-24-423.552v59.136a32.064 32.064 0 0 0 64 0V246.784c0-9.6-3.2-17.536-9.6-22.4a31.616 31.616 0 0 0-22.4-9.536h-128c-17.6 0-32 14.4-32 32 0 17.536 14.4 31.936 32 31.936h44.8c-119.936 148.608-108.8 366.016 28.8 505.088 96 95.872 228.736 129.408 351.872 103.872a41.92 41.92 0 0 0 14.4-8c12.8-12.8 12.8-32 0-44.8-6.4-9.6-19.2-12.736-28.8-9.6z m281.6-78.336h-43.264a383.424 383.424 0 0 0-32-506.624c-89.536-89.536-211.072-124.672-327.872-108.736a28.16 28.16 0 0 0-20.8 9.6c-12.8 12.8-12.8 32 0 44.8 8 7.936 19.2 11.136 30.4 7.936 96-14.336 198.4 16 271.936 89.536a316.416 316.416 0 0 1 24 423.552v-59.136a32.064 32.064 0 0 0-64 0v127.872c0 9.6 3.2 17.536 9.6 22.4 6.4 6.4 14.4 9.6 22.4 9.6h128c17.536 0 32-14.464 32-32 0-17.6-12.8-28.8-30.464-28.8z'></path>
      </svg>
    )
  }

  if (fontClass === 'icon-line-global_search') {
    return (
      <svg
        className={classNames}
        style={{
          ...style,
        }}
        viewBox='0 0 1024 1024'
        version='1.1'
        xmlns='http://www.w3.org/2000/svg'
        color='currentColor'
      >
        <path d='M506.24 128a378.24 378.24 0 0 1 289.408 621.824l154.88 154.88a32.384 32.384 0 0 1-41.344 49.536l-4.48-3.776-154.88-154.88A378.24 378.24 0 1 1 506.24 128z m0 64.704a313.536 313.536 0 1 0 0 627.072 313.536 313.536 0 0 0 0-627.072z'></path>
      </svg>
    )
  }

  if (fontClass === 'icon-line-global_left') {
    return (
      <svg
        className={classNames}
        style={{
          ...style,
        }}
        viewBox='0 0 1024 1024'
        version='1.1'
        xmlns='http://www.w3.org/2000/svg'
        color='currentColor'
      >
        <path d='M273.024 486.4a36.288 36.288 0 0 0-3.2 47.552l3.2 3.712 341.312 341.312a36.288 36.288 0 0 0 54.528-47.552l-3.2-3.712L350.016 512 665.6 196.288a36.288 36.288 0 0 0 3.2-47.552l-3.2-3.712a36.288 36.288 0 0 0-47.616-3.2l-3.712 3.2-341.312 341.312z'></path>
      </svg>
    )
  }

  if (fontClass === 'icon-line-global_right') {
    return (
      <svg
        className={classNames}
        style={{
          ...style,
        }}
        viewBox='0 0 1024 1024'
        version='1.1'
        xmlns='http://www.w3.org/2000/svg'
        color='currentColor'
      >
        <path d='M750.976 486.4c12.992 12.928 14.08 33.28 3.2 47.552l-3.2 3.712-341.312 341.312a36.288 36.288 0 0 1-54.528-47.552l3.2-3.712L673.984 512 358.4 196.288a36.288 36.288 0 0 1-3.2-47.552l3.2-3.712a36.288 36.288 0 0 1 47.616-3.2l3.712 3.2 341.312 341.312z'></path>
      </svg>
    )
  }

  if (fontClass === 'icon-line-global_Translate') {
    return (
      <svg
        className={classNames}
        style={{
          ...style,
        }}
        viewBox='0 0 1024 1024'
        version='1.1'
        xmlns='http://www.w3.org/2000/svg'
        color='currentColor'
      >
        <path d='M152.448 680.064c20.8 0 37.632 16.768 37.632 37.504v97.088c0 23.808 19.264 43.136 43.072 43.136h141.76a37.568 37.568 0 1 1 0 75.072H190.784a75.904 75.904 0 0 1-75.904-75.904v-139.392c0-20.736 16.832-37.504 37.568-37.504z m607.872-222.208l3.648 0.448a15.36 15.36 0 0 1 8.832 5.952l1.728 3.2 177.92 444.352a15.296 15.296 0 0 1-14.208 21.056h-48a15.36 15.36 0 0 1-14.208-9.6l-47.872-119.424-6.4-4.288H639.808l-6.4 4.352-47.744 119.296a15.36 15.36 0 0 1-14.272 9.6H523.52a15.36 15.36 0 0 1-14.208-20.992l177.92-444.352a15.36 15.36 0 0 1 14.272-9.6h58.816z m-23.04 118.72h-12.8l-55.488 138.432 6.4 9.472h110.848l6.4-9.472-55.36-138.432zM308.224 102.4a15.36 15.36 0 0 1 15.36 15.36v66.56l6.848 6.976h155.712a15.36 15.36 0 0 1 15.36 15.296v266.624a15.36 15.36 0 0 1-15.36 15.296H330.432l-6.912 6.912v111.04a15.36 15.36 0 0 1-15.36 15.36H263.68a15.36 15.36 0 0 1-15.36-15.36V495.424l-6.848-6.912H85.76a15.36 15.36 0 0 1-15.36-15.36V206.656a15.36 15.36 0 0 1 15.36-15.36h155.712l6.912-6.848V117.696a15.36 15.36 0 0 1 15.36-15.296zM241.472 266.304h-88.96l-6.912 6.912v133.312l6.848 6.912h88.96l6.976-6.912V273.28l-6.912-6.912z m177.92 0h-88.96l-6.912 6.912v133.312l6.912 6.912h88.96l6.912-6.912V273.28l-6.912-6.912z m402.368-129.088c41.92 0 75.904 33.92 75.904 75.904v139.328a37.568 37.568 0 0 1-75.2 0V255.36a43.136 43.136 0 0 0-43.072-43.136H637.632a37.568 37.568 0 1 1 0-75.008z'></path>
      </svg>
    )
  }

  if (fontClass === 'icon-line-global_TranslateClick1') {
    return (
      <svg
        className={classNames}
        style={{
          ...style,
        }}
        viewBox='0 0 1024 1024'
        version='1.1'
        xmlns='http://www.w3.org/2000/svg'
        color='currentColor'
      >
        <path d='M152.448 667.264c27.84 0 50.432 22.528 50.432 50.304v97.088c0 16.704 13.568 30.336 30.272 30.336h141.76a50.368 50.368 0 1 1 0 100.672H190.784c-48.96 0-88.704-39.744-88.704-88.704v-139.392c0-27.776 22.592-50.304 50.368-50.304z m607.872-222.208l1.472 0.128 5.248 0.64a28.864 28.864 0 0 1 17.024 12.352l2.368 4.544 177.92 444.352a28.096 28.096 0 0 1-26.112 38.592h-48a28.16 28.16 0 0 1-26.112-17.664l-46.4-115.712h-173.952L597.568 928a28.16 28.16 0 0 1-21.312 17.28l-4.864 0.384H523.52a28.16 28.16 0 0 1-26.112-38.592l177.92-444.352a28.16 28.16 0 0 1 26.176-17.664h58.816z m-29.504 150.016l-46.72 116.544h93.376l-46.656-116.544zM308.224 89.6a28.16 28.16 0 0 1 28.16 28.16l-0.064 60.672h149.824a28.16 28.16 0 0 1 27.712 23.04l0.448 5.12v266.624a28.16 28.16 0 0 1-28.16 28.096l-149.824-0.064v105.216a28.16 28.16 0 0 1-23.04 27.712l-5.12 0.448H263.68a28.16 28.16 0 0 1-28.16-28.16V501.248H85.76a28.16 28.16 0 0 1-15.616-4.672l-4.288-3.52a28.16 28.16 0 0 1-8.256-19.84V206.592a28.16 28.16 0 0 1 28.16-28.16h149.76v-60.736c0-5.568 1.728-11.008 4.8-15.552l3.456-4.288A28.16 28.16 0 0 1 263.68 89.6h44.544z m513.536 34.816c49.024 0 88.704 39.68 88.704 88.704v139.328a50.368 50.368 0 0 1-100.8 0V255.36a30.336 30.336 0 0 0-30.272-30.336H637.632a50.368 50.368 0 1 1 0-100.608h184.128zM413.504 279.04H336.32v121.472h77.184V279.104z m-177.984 0H158.336v121.472H235.52V279.104z'></path>
      </svg>
    )
  }

  if (fontClass === 'icon-line-global_Chat') {
    return (
      <svg
        className={classNames}
        style={{
          ...style,
        }}
        viewBox='0 0 1024 1024'
        version='1.1'
        xmlns='http://www.w3.org/2000/svg'
        color='currentColor'
      >
        <path d='M659.968 172.288l-8.512 2.624-6.592 2.368-4.736 1.92-6.592 3.2-7.168 4.48a83.2 83.2 0 0 0-33.024 46.08A335.104 335.104 0 1 0 486.4 885.504h299.712l5.76-9.472-52.288-104.704 14.976-19.904a334.976 334.976 0 0 0 59.968-269.44 84.224 84.224 0 0 0 73.216-41.664 416 416 0 0 1-50.56 333.76l-1.28 2.112 55.488 118.016c2.56 5.12 4.224 10.752 4.864 16.512l0.384 6.144a49.728 49.728 0 0 1-36.608 47.68l-5.76 1.152-2.048 0.256-5.888 0.384H486.4a416 416 0 1 1 173.568-794.112zM793.408 111.68a21.504 21.504 0 0 1 39.296-4.8l1.984 4.8 24.704 85.12a21.632 21.632 0 0 0 10.56 13.056l4.032 1.6 84.544 24.832c18.944 5.568 20.48 30.72 4.736 39.616l-4.736 1.92-84.48 24.896a21.568 21.568 0 0 0-13.056 10.688l-1.6 4.032-24.704 85.12a21.504 21.504 0 0 1-39.36 4.736l-1.92-4.736-24.704-85.12a21.632 21.632 0 0 0-10.56-13.056l-4.032-1.664-84.608-24.832c-18.88-5.568-20.48-30.72-4.736-39.616l4.736-1.92 84.608-24.896a21.568 21.568 0 0 0 12.992-10.624l1.6-4.096 24.704-85.12zM329.6 435.2h300.8a41.6 41.6 0 0 1 0 83.2h-300.8a41.6 41.6 0 1 1 0-83.2zM329.6 608h172.8a41.6 41.6 0 0 1 0 83.2h-172.8a41.6 41.6 0 1 1 0-83.2z'></path>
      </svg>
    )
  }

  if (fontClass === 'icon-line-global_ChatClick') {
    return (
      <svg
        className={classNames}
        style={{
          ...style,
        }}
        viewBox='0 0 1024 1024'
        version='1.1'
        xmlns='http://www.w3.org/2000/svg'
        color='currentColor'
      >
        <path d='M669.44 169.6l-17.92 5.312-6.656 2.368-4.736 1.92-6.592 3.2-7.168 4.48c-57.152 39.488-45.504 131.648 25.152 152.384l62.144 18.24 18.24 62.848 2.304 6.592 1.92 4.736 3.2 6.592 4.48 7.232c37.12 54.336 121.408 46.976 148.16-13.568a422.208 422.208 0 0 1-49.408 345.728l-1.28 2.048 55.872 111.68a56.32 56.32 0 0 1 5.504 18.688l0.384 6.528a56.32 56.32 0 0 1-41.344 54.272l-6.208 1.28-2.496 0.32-6.272 0.448H486.4A422.464 422.464 0 1 1 669.44 169.6zM502.4 608h-172.8a41.6 41.6 0 0 0 0 83.2h172.8a41.6 41.6 0 0 0 0-83.2z m128-172.8h-300.8a41.6 41.6 0 0 0 0 83.2h300.8a41.6 41.6 0 0 0 0-83.2zM793.408 111.68a21.504 21.504 0 0 1 39.296-4.8l1.984 4.8 24.704 85.12a21.632 21.632 0 0 0 10.56 13.056l4.032 1.6 84.544 24.832c18.944 5.568 20.48 30.72 4.736 39.616l-4.736 1.92-84.48 24.896a21.568 21.568 0 0 0-13.056 10.688l-1.6 4.032-24.704 85.12a21.504 21.504 0 0 1-39.36 4.736l-1.92-4.736-24.704-85.12a21.632 21.632 0 0 0-10.56-13.056l-4.032-1.664-84.608-24.832c-18.88-5.568-20.48-30.72-4.736-39.616l4.736-1.92 84.608-24.896a21.568 21.568 0 0 0 12.992-10.624l1.6-4.096 24.704-85.12z'></path>
      </svg>
    )
  }

  if (fontClass === 'icon-line-global_CustomerService') {
    return (
      <svg
        className={classNames}
        style={{
          ...style,
        }}
        viewBox='0 0 1024 1024'
        version='1.1'
        xmlns='http://www.w3.org/2000/svg'
        color='currentColor'
      >
        <path d='M512 124.8c214.016 0 387.2 177.6 387.2 396.224v108.288a35.2 35.2 0 0 1-70.4 0V521.024c0-180.16-142.08-325.824-316.8-325.824S195.2 340.864 195.2 521.024v108.288a35.2 35.2 0 1 1-70.4 0V521.024C124.8 302.4 297.984 124.8 512 124.8zM864 555.008a35.2 35.2 0 0 1 35.2 35.2V864a35.2 35.2 0 0 1-35.2 35.2h-78.208a113.408 113.408 0 0 1-113.408-113.408v-117.376c0-62.592 50.752-113.408 113.408-113.408H864z m-35.2 273.728V625.408h-43.008a43.008 43.008 0 0 0-42.56 36.672l-0.448 6.4v117.312c0 23.744 19.2 43.008 43.008 43.008h43.008zM238.208 555.008c62.656 0 113.408 50.816 113.408 113.408v117.376c0 62.656-50.752 113.408-113.408 113.408H160a35.2 35.2 0 0 1-35.2-35.2V590.208a35.2 35.2 0 0 1 35.2-35.2h78.208zM195.2 828.8l43.008 0.064a43.008 43.008 0 0 0 43.008-43.008v-117.376a43.008 43.008 0 0 0-43.008-43.008H195.2v203.328z'></path>
      </svg>
    )
  }

  if (fontClass === 'icon-shezhi') {
    return (
      <svg
        className={classNames}
        style={{
          width: '1.166015625em',
          height: '1em',
          verticalAlign: 'middle',
          fill: 'currentColor',
          overflow: 'hidden',
          ...style,
        }}
        viewBox='0 0 1024 1024'
        version='1.1'
        xmlns='http://www.w3.org/2000/svg'
        color='currentColor'
      >
        <path d='M841.642667 0H337.066667a42.069333 42.069333 0 0 0-36.266667 20.736L48.469333 449.621333a42.069333 42.069333 0 0 0 0 42.666667l252.330667 428.970667c7.509333 12.8 21.333333 20.650667 36.266667 20.650666h504.576a42.069333 42.069333 0 0 0 36.266666-20.650666l252.245334-428.970667a42.069333 42.069333 0 0 0 0-42.666667L877.909333 20.736A42.069333 42.069333 0 0 0 841.642667 0z m-24.064 84.138667l227.584 386.730666-227.584 386.986667h-456.533334L133.376 470.954667 361.045333 84.138667h456.533334zM589.312 302.762667a168.192 168.192 0 1 0 0 336.384 168.192 168.192 0 0 0 0-336.384z m0 84.138666a84.138667 84.138667 0 1 1 0 168.106667 84.138667 84.138667 0 0 1 0-168.106667z'></path>
      </svg>
    )
  }

  if (fontClass === 'icon-line-global_Study') {
    return (
      <svg
        className={classNames}
        style={{
          ...style,
        }}
        viewBox='0 0 1024 1024'
        version='1.1'
        xmlns='http://www.w3.org/2000/svg'
        color='currentColor'
      >
        <path d='M253.888 198.208c63.36 0 126.464 16 189.12 47.552l15.808 8.32L448 248.32c58.624-30.4 117.504-46.976 176.704-49.664a88.32 88.32 0 0 0-12.096 54.912c-43.968 3.968-88.128 17.088-132.672 39.296l-4.224 2.176v532.736l10.24-4.416a409.024 409.024 0 0 1 138.752-32l17.408-0.32c52.352 0 104.384 10.88 156.16 32.32l10.24 4.48V469.056c17.536 7.232 37.248 8.576 55.552 4.032l-0.064 398.72c0 9.664-5.248 18.56-13.824 23.36a28.416 28.416 0 0 1-27.648 0.064c-60.672-33.664-120.704-50.304-180.416-50.304-59.648 0-119.68 16.64-180.352 50.304a29.888 29.888 0 0 1-11.136 3.456 25.728 25.728 0 0 1-9.6-0.768l-3.52-1.088-2.176-0.96-1.088-0.576c-60.672-33.792-120.704-50.368-180.352-50.368-59.712 0-119.68 16.64-180.416 50.304a28.416 28.416 0 0 1-27.648-0.064 26.816 26.816 0 0 1-13.824-23.296V279.04c0-9.6 5.312-18.56 13.952-23.36 68.8-38.144 138.112-57.472 207.936-57.472z m0 53.888c-53.76 0-107.712 13.568-162.24 40.768l-4.288 2.176 0.128 532.736 10.24-4.416a409.024 409.024 0 0 1 138.752-32l17.408-0.32c52.288 0 104.32 10.88 156.16 32.32l10.24 4.48V295.04l-2.56-1.344c-49.536-25.024-98.688-38.656-147.584-41.152l-16.256-0.448zM821.056 92.992a22.4 22.4 0 0 1 40.96-4.928l1.984 4.928 25.664 88.512c1.728 5.888 5.76 10.816 11.008 13.632l4.224 1.664 87.936 25.856c19.648 5.76 21.312 32 4.928 41.152l-4.928 2.048-87.936 25.856a22.4 22.4 0 0 0-13.504 11.072l-1.728 4.224L864 395.52a22.4 22.4 0 0 1-40.96 4.928l-1.984-4.928-25.664-88.512a22.464 22.464 0 0 0-11.008-13.568l-4.224-1.728-87.936-25.856c-19.648-5.76-21.312-32-4.928-41.152l4.928-2.048 87.936-25.856a22.4 22.4 0 0 0 13.504-11.072l1.728-4.224 25.664-88.512z'></path>
      </svg>
    )
  }

  if (fontClass === 'icon-line-global_StudyClick1') {
    return (
      <svg
        className={classNames}
        style={{
          ...style,
        }}
        viewBox='0 0 1024 1024'
        version='1.1'
        xmlns='http://www.w3.org/2000/svg'
        color='currentColor'
      >
        <path d='M642.304 188.16l-9.344 15.424c-25.792 42.432-6.464 99.712 43.968 114.496l65.984 19.328 6.528 6.528 19.2 66.304 2.816 8.192c14.528 36.672 52.992 54.592 90.304 45.376l11.904-2.944v12.288l-0.064 398.72a36.416 36.416 0 0 1-18.688 31.68c-11.52 6.4-25.6 6.464-37.12 0.128-59.136-32.896-117.568-49.152-175.68-49.152-53.568 0-107.456 13.888-162.112 41.856V222.72l3.52-1.536a423.36 423.36 0 0 1 120.576-30.72l20.224-1.408 17.92-0.832z m-388.48 0.448a414.72 414.72 0 0 1 162.24 34.112L416 896.512l-4.16-2.176c-52.992-26.624-105.6-39.808-157.952-39.808-58.048 0-116.48 16.32-175.744 49.152-11.52 6.4-25.6 6.336-37.056-0.128a36.416 36.416 0 0 1-18.688-31.68V279.04c0-13.184 7.232-25.28 18.944-31.744 70.336-39.04 141.248-58.688 212.48-58.688zM821.056 92.992a22.4 22.4 0 0 1 40.96-4.928l1.984 4.928 25.664 88.512c1.728 5.888 5.76 10.816 11.008 13.632l4.224 1.664 87.936 25.856c19.648 5.76 21.312 32 4.928 41.152l-4.928 2.048-87.936 25.856a22.4 22.4 0 0 0-13.504 11.072l-1.728 4.224L864 395.52a22.4 22.4 0 0 1-40.96 4.928l-1.984-4.928-25.664-88.512a22.464 22.464 0 0 0-11.008-13.568l-4.224-1.728-87.936-25.856c-19.648-5.76-21.312-32-4.928-41.152l4.928-2.048 87.936-25.856a22.4 22.4 0 0 0 13.504-11.072l1.728-4.224 25.664-88.512z'></path>
      </svg>
    )
  }

  if (fontClass === 'icon-line-global_File') {
    return (
      <svg
        className={classNames}
        style={{
          ...style,
        }}
        viewBox='0 0 1024 1024'
        version='1.1'
        xmlns='http://www.w3.org/2000/svg'
        color='currentColor'
      >
        <path d='M746.048 604.736a22.336 22.336 0 0 1 42.944 0l25.664 88.512a22.4 22.4 0 0 0 15.232 15.296l87.936 25.856c21.44 6.272 21.44 36.864 0 43.2l-87.936 25.856a22.4 22.4 0 0 0-15.232 15.296l-25.664 88.512a22.336 22.336 0 0 1-42.88 0l-25.728-88.512a22.4 22.4 0 0 0-15.232-15.36l-87.936-25.792c-21.44-6.336-21.44-36.928 0-43.2l87.936-25.856a22.4 22.4 0 0 0 15.232-15.36z m51.84-508.736c41.088 0 74.368 33.28 74.368 74.368v323.328a12.8 12.8 0 0 1-12.8 12.8h-48.832a12.8 12.8 0 0 1-12.8-12.8V170.24H202.368v669.12h285.44c7.04 0 12.8 5.76 12.8 12.8v48.832a12.8 12.8 0 0 1-12.8 12.8H202.432c-41.088 0-74.432-33.28-74.432-74.368V170.368C128 129.28 161.28 96 202.432 96zM561.728 527.104c7.04 0 12.8 5.76 12.8 12.8v48.704a12.8 12.8 0 0 1-12.8 12.8H289.664a12.8 12.8 0 0 1-12.8-12.8v-48.704c0-7.04 5.76-12.8 12.8-12.8h272.128z m148.864-185.92c7.04 0 12.8 5.76 12.8 12.8v48.768a12.8 12.8 0 0 1-12.8 12.8H289.664a12.8 12.8 0 0 1-12.8-12.8v-48.768c0-7.04 5.76-12.8 12.8-12.8h420.992z'></path>
      </svg>
    )
  }

  if (fontClass === 'icon-fill-global_FileClick') {
    return (
      <svg
        className={classNames}
        style={{
          ...style,
        }}
        viewBox='0 0 1024 1024'
        version='1.1'
        xmlns='http://www.w3.org/2000/svg'
        color='currentColor'
      >
        <path d='M788.992 604.736l25.664 88.512a22.4 22.4 0 0 0 15.232 15.296l34.88 10.176 53.056 15.68c19.648 5.76 21.312 32 4.928 41.152l-4.928 2.048-87.936 25.856a22.272 22.272 0 0 0-13.504 11.072l-1.728 4.224-25.664 88.512a22.336 22.336 0 0 1-42.88 0l-5.248-17.984-20.48-70.528a22.4 22.4 0 0 0-15.232-15.36l-87.936-25.792c-21.44-6.336-21.44-36.928 0-43.2l87.936-25.856a22.4 22.4 0 0 0 15.232-15.36l25.664-88.448a22.336 22.336 0 0 1 42.944 0z m8.832-508.736c41.152 0 74.432 33.28 74.432 74.368v497.216l-12.8-3.712-21.312-73.408c-20.48-70.848-120.704-70.848-141.248 0l-21.248 73.408-72.832 21.376-8.128 2.88c-62.272 25.728-59.52 118.72 8.128 138.56l72.768 21.376 18.944 65.664-1.92 0.064H202.496c-41.088 0-74.432-33.28-74.432-74.24V170.304C128 129.28 161.28 96 202.432 96h595.392zM561.792 527.104H289.664a12.8 12.8 0 0 0-12.8 12.8v48.704c0 7.04 5.76 12.8 12.8 12.8h272.128a12.8 12.8 0 0 0 12.8-12.8v-48.704a12.8 12.8 0 0 0-12.8-12.8z m148.864-185.92H289.664a12.8 12.8 0 0 0-12.8 12.8v48.768c0 7.04 5.76 12.8 12.8 12.8h420.992a12.8 12.8 0 0 0 12.8-12.8v-48.768a12.8 12.8 0 0 0-12.8-12.8z'></path>
      </svg>
    )
  }

  if (fontClass === 'icon-line-global_setup') {
    return (
      <svg
        className={classNames}
        style={{
          verticalAlign: 'middle',
          fill: 'currentColor',
          overflow: 'hidden',
          ...style,
        }}
        viewBox='0 0 1024 1024'
        version='1.1'
        xmlns='http://www.w3.org/2000/svg'
        color='currentColor'
      >
        <path d='M967.936 641.4336v57.344h-479.232v-57.344h479.232z m0-286.464v57.2928h-114.5856v-57.344h114.5856z m-658.944 286.464v57.344H51.2v-57.344h257.8432z m401.1008-286.464v57.2928H51.2v-57.344h658.944zM284.9792 657.0496c0-63.2832 53.3504-114.5856 119.1424-114.5856 65.8432 0 119.1936 51.3024 119.1936 114.5856s-53.3504 114.5856-119.1936 114.5856c-65.792 0-119.1424-51.3024-119.1424-114.5856z m178.7392 0c0-31.6416-26.624-57.2928-59.5968-57.2928-32.8704 0-59.5456 25.6512-59.5456 57.344 0 31.5904 26.624 57.2416 59.5456 57.2416s59.5968-25.6 59.5968-57.2928z m208.5888-286.464C672.256 307.3024 725.6576 256 791.4496 256c65.8432 0 119.1936 51.3024 119.1936 114.5856s-53.3504 114.5856-119.1936 114.5856c-31.5904 0-61.952-12.0832-84.2752-33.536a112.384 112.384 0 0 1-34.8672-81.0496z m178.688 0c0-31.6416-26.624-57.2928-59.5456-57.2928s-59.5968 25.6512-59.5968 57.344c0 31.5904 26.6752 57.2416 59.5968 57.2416 32.9216 0 59.5968-25.6 59.5968-57.2928z'></path>
      </svg>
    )
  }

  // if (fontClass === 'icon-line-global_FullScreen') {
  //   return (
  //     <svg
  //       className={classNames}
  //       style={{
  //         verticalAlign: 'middle',
  //         fill: 'currentColor',
  //         overflow: 'hidden',
  //         ...style,
  //       }}
  //       viewBox='0 0 1024 1024'
  //       version='1.1'
  //       xmlns='http://www.w3.org/2000/svg'
  //       color='currentColor'
  //     >
  //       <path d='M161.92 565.632a34.432 34.432 0 0 1 12.992 2.56l5.824 3.2 2.688 1.92 2.496 2.24c1.6 1.6 2.944 3.2 4.16 5.056l1.728 2.944 2.56 6.08 1.28 6.592 0.192 222.08 9.856 9.856h218.752c2.24 0 4.48 0.256 6.656 0.64l3.2 0.832 6.144 2.56 5.568 3.648 2.432 2.24a33.408 33.408 0 0 1 4.224 5.12l3.2 5.952c0.768 1.92 1.408 4.032 1.792 6.208 0.512 2.304 0.704 4.48 0.704 6.72l-0.64 6.592-1.92 6.4-3.2 5.888a33.536 33.536 0 0 1-4.16 5.12l-5.12 4.16a36.352 36.352 0 0 1-5.888 3.2l-3.072 1.088-6.592 1.28L161.92 896a34.432 34.432 0 0 1-6.656-0.64l-3.2-0.832-6.144-2.56-2.88-1.664a33.536 33.536 0 0 1-5.12-4.224l-4.16-5.12a36.352 36.352 0 0 1-3.2-5.952l-1.088-3.008-1.28-6.592L128 599.552c0-2.24 0.192-4.48 0.64-6.656l0.832-3.2 2.56-6.144 1.664-2.88a33.536 33.536 0 0 1 4.224-5.12l5.184-4.288 5.888-3.136a32.96 32.96 0 0 1 12.928-2.56z m434.304-437.44L862.08 128c2.304 0 4.48 0.192 6.592 0.64l3.264 0.832 6.144 2.56 2.88 1.664c1.792 1.28 3.52 2.688 5.12 4.224l4.16 5.12c1.28 1.92 2.368 3.84 3.2 5.952l1.088 3.008 0.768 3.2A32.96 32.96 0 0 1 896 161.92v262.528c0 2.24-0.192 4.48-0.64 6.656l-0.832 3.2-2.56 6.144-1.664 2.88a33.536 33.536 0 0 1-9.344 9.344l-5.952 3.2a32.256 32.256 0 0 1-12.928 2.56l-6.592-0.64-6.4-1.92-5.824-3.2-2.688-1.92-4.736-4.736-3.648-5.568-2.56-6.08-1.28-6.592-0.192-222.08-9.856-9.856H599.552a34.432 34.432 0 0 1-6.656-0.64l-3.2-0.832-6.144-2.56-5.568-3.648-2.432-2.24a35.52 35.52 0 0 1-4.288-5.184l-3.136-5.888a30.528 30.528 0 0 1-1.792-6.208l-0.704-6.72a34.432 34.432 0 0 1 2.56-12.992l3.2-5.888a33.536 33.536 0 0 1 4.16-5.12l5.056-4.16a36.48 36.48 0 0 1 5.952-3.2l3.072-1.088 6.592-1.28z'></path>
  //     </svg>
  //   )
  // }

  if (fontClass === 'icon-line-global_FullScreen') {
    return (
      <svg
        className={classNames}
        style={{
          verticalAlign: 'middle',
          fill: 'currentColor',
          overflow: 'hidden',
          ...style,
        }}
        viewBox='0 0 1024 1024'
        version='1.1'
        xmlns='http://www.w3.org/2000/svg'
        color='currentColor'
      >
        <path d='M161.92 565.632a34.432 34.432 0 0 1 12.992 2.56l5.824 3.2 2.688 1.92 2.496 2.24c1.6 1.6 2.944 3.2 4.16 5.056l1.728 2.944 2.56 6.08 1.28 6.592 0.192 222.08 9.856 9.856h218.752c2.24 0 4.48 0.256 6.656 0.64l3.2 0.832 6.144 2.56 5.568 3.648 2.432 2.24a33.408 33.408 0 0 1 4.224 5.12l3.2 5.952c0.768 1.92 1.408 4.032 1.792 6.208 0.512 2.304 0.704 4.48 0.704 6.72l-0.64 6.592-1.92 6.4-3.2 5.888a33.536 33.536 0 0 1-4.16 5.12l-5.12 4.16a36.352 36.352 0 0 1-5.888 3.2l-3.072 1.088-6.592 1.28L161.92 896a34.432 34.432 0 0 1-6.656-0.64l-3.2-0.832-6.144-2.56-2.88-1.664a33.536 33.536 0 0 1-5.12-4.224l-4.16-5.12a36.352 36.352 0 0 1-3.2-5.952l-1.088-3.008-1.28-6.592L128 599.552c0-2.24 0.192-4.48 0.64-6.656l0.832-3.2 2.56-6.144 1.664-2.88a33.536 33.536 0 0 1 4.224-5.12l5.184-4.288 5.888-3.136a32.96 32.96 0 0 1 12.928-2.56z m434.304-437.44L862.08 128c2.304 0 4.48 0.192 6.592 0.64l3.264 0.832 6.144 2.56 2.88 1.664c1.792 1.28 3.52 2.688 5.12 4.224l4.16 5.12c1.28 1.92 2.368 3.84 3.2 5.952l1.088 3.008 0.768 3.2A32.96 32.96 0 0 1 896 161.92v262.528c0 2.24-0.192 4.48-0.64 6.656l-0.832 3.2-2.56 6.144-1.664 2.88a33.536 33.536 0 0 1-9.344 9.344l-5.952 3.2a32.256 32.256 0 0 1-12.928 2.56l-6.592-0.64-6.4-1.92-5.824-3.2-2.688-1.92-4.736-4.736-3.648-5.568-2.56-6.08-1.28-6.592-0.192-222.08-9.856-9.856H599.552a34.432 34.432 0 0 1-6.656-0.64l-3.2-0.832-6.144-2.56-5.568-3.648-2.432-2.24a35.52 35.52 0 0 1-4.288-5.184l-3.136-5.888a30.528 30.528 0 0 1-1.792-6.208l-0.704-6.72a34.432 34.432 0 0 1 2.56-12.992l3.2-5.888a33.536 33.536 0 0 1 4.16-5.12l5.056-4.16a36.48 36.48 0 0 1 5.952-3.2l3.072-1.088 6.592-1.28z'></path>
      </svg>
    )
  }

  if (fontClass === 'icon-line-global_close') {
    return (
      <svg
        className={classNames}
        style={{
          verticalAlign: 'middle',
          fill: 'currentColor',
          overflow: 'hidden',
          ...style,
        }}
        viewBox='0 0 1024 1024'
        version='1.1'
        xmlns='http://www.w3.org/2000/svg'
        color='currentColor'
      >
        <path d='M814.464 209.536a31.744 31.744 0 0 1 2.816 41.6l-2.816 3.328L556.8 512l257.6 257.536a31.744 31.744 0 0 1-41.6 47.744l-3.328-2.816L512 556.8l-257.536 257.6a31.744 31.744 0 0 1-47.744-41.6l2.816-3.328L467.2 512 209.536 254.464a31.744 31.744 0 0 1 41.6-47.744l3.328 2.816L512 467.2l257.536-257.6a31.744 31.744 0 0 1 44.928 0z'></path>
      </svg>
    )
  }

  if (fontClass === 'icon-biz-help') {
    return (
      <svg 
      className={classNames}
        style={{
          width:'16px',
          height:'16px',
          verticalAlign: 'middle',
          fill: 'currentColor',
          overflow: 'hidden',
          ...style,
        }}
      viewBox="0 0 1024 1024" 
      version="1.1" 
      xmlns="http://www.w3.org/2000/svg" 
      color='currentColor'
      >
        <path d="M192 64h639.808a128 128 0 0 1 128 128v513.28a128 128 0 0 1-128 128H666.88l-105.28 104.704a70.4 70.4 0 0 1-99.392-0.064l-104.832-104.704H192a128 128 0 0 1-128-128V192a128 128 0 0 1 128-128z m242.368 301.312c0-48.256 32.128-76.096 77.056-75.264 44.864 0.768 78.144 29.888 78.144 75.264 0 30.72-6.528 40.704-33.664 60.672l-8.256 6.08c-46.528 34.688-67.712 71.552-67.712 144.32a32 32 0 1 0 64 0c0-51.072 10.688-69.696 41.984-92.992l7.936-5.888c41.92-30.912 59.712-57.856 59.712-112.192 0-82.56-63.168-137.92-141.056-139.264-78.976-1.408-142.144 53.248-142.144 139.264a32 32 0 1 0 64 0z m77.44 339.328a32 32 0 1 0 0-64 32 32 0 0 0 0 64z" fill="#000000" p-id="3828"></path>
      </svg>
    )
  }

  return null
}
